import React, { useEffect, useState } from 'react'
import { Alert, Space, Tag, Tooltip } from 'antd'
import { getRequest, inventoryStatusUrl } from '../../config'
import {
  botDisplay,
  canaryDisplay,
  fetchDisplay,
  formatDateTime,
  ladderDisplay,
  formatUsd
} from './utils'

// Is the bot alive? One strip at the top of every Inventory assistant screen, so whoever opens a page
// to find out why the bot has gone quiet sees the answer first. The webhook, the last message and
// the scraper check all come from the server: this dashboard cannot see the server's environment.
const HealthStrip = () => {
  const [status, setStatus] = useState(null)

  useEffect(() => {
    let alive = true
    // Best-effort and silent: a strip that cannot load must not toast over the page it sits on.
    getRequest(inventoryStatusUrl, 'bot status', () => {}).then(response => {
      if (alive && response.success) setStatus(response.data)
    })
    return () => {
      alive = false
    }
  }, [])

  if (!status) return null
  const canary = canaryDisplay(status.canary)
  const fetching = fetchDisplay(status.fetching)
  const ladder = ladderDisplay(status.fetching)

  return (
    <div style={{ marginBottom: 16 }}>
      <Space wrap size={[8, 8]}>
        {(status.bots || []).map(bot => {
          const d = botDisplay(bot)
          return (
            <Tooltip
              key={bot.slug}
              title={
                bot.lastError
                  ? `Telegram says: ${bot.lastError}`
                  : bot.pendingUpdates
                  ? `${bot.pendingUpdates} messages waiting to be delivered`
                  : null
              }
            >
              <Tag color={d.color}>
                {bot.username ? `@${bot.username}` : bot.name} · {d.label}
              </Tag>
            </Tooltip>
          )
        })}
        {(status.bots || []).length === 0 ? <Tag color="red">No bot is set up</Tag> : null}
        <Tag>Last message: {formatDateTime(status.lastUpdateAt)}</Tag>
        <Tag color={canary.color}>{canary.label}</Tag>
        <Tag>AI spend today: {formatUsd(status.spendToday)}</Tag>
        {fetching ? <Tag color={fetching.color}>{fetching.label}</Tag> : null}
        {ladder ? (
          <Tooltip title="The order the API tries, cheapest first">
            <span>
              {ladder.map((rung, i) => (
                <Tooltip key={rung.name} title={rung.title}>
                  <Tag color={rung.color} style={{ marginRight: i === ladder.length - 1 ? 8 : 4 }}>
                    {rung.label}
                  </Tag>
                </Tooltip>
              ))}
            </span>
          </Tooltip>
        ) : null}
      </Space>
      {canary.problems && canary.problems.length ? (
        <Alert
          style={{ marginTop: 8 }}
          type="error"
          showIcon
          message="A listing scraper may have stopped working"
          description={
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {canary.problems.map(p => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          }
        />
      ) : null}
    </div>
  )
}

export default HealthStrip
